module.exports = __webpack_public_path__ + "assets/imgs/people-about-us-img-1.v1.jpg";